import * as Api from '@ViewModels';

export function getAutomationReportCreator(
	automationReport: Api.IAutomationReport
): Api.IUserReference | Api.UserReference | undefined {
	const actualSteps = automationReport.steps.filter(step => step._type !== 'SwitchAutomationStep');
	if (actualSteps.length === 1 && actualSteps[0].sender?.id) {
		return actualSteps[0].sender;
	}

	return automationReport.creator;
}

export function getAutomationReportSubject(automationReport: Api.IAutomationReport): string | undefined {
	if (
		automationReport.automationStep._type === 'EmailAutomationStep' ||
		automationReport.automationStep._type === 'HtmlNewsletterAutomationStep' ||
		automationReport.automationStep._type === 'AIEmailAutomationStep'
	) {
		const emailStep = automationReport.automationStep as unknown as Api.IEmailAutomationStep;
		// An AI email step carries only `subject` -- it is written at send time, not through the compose options.
		return emailStep.options?.subject ?? emailStep.subject;
	}
	return undefined;
}
